import { render, staticRenderFns } from "./resolutionIndicator.vue?vue&type=template&id=7a95a83b&scoped=true&lang=pug&"
import script from "./resolutionIndicator.vue?vue&type=script&lang=js&"
export * from "./resolutionIndicator.vue?vue&type=script&lang=js&"
import style0 from "./resolutionIndicator.vue?vue&type=style&index=0&id=7a95a83b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a95a83b",
  null
  
)

export default component.exports